// Register a global custom directive called `v-focus`
export default {
  // When the bound element is inserted into the DOM...
  inserted: function (el, binding, node) {
    // Focus the element
    if (binding.value === undefined || binding.value === true) {
      el.focus();
    }
  }
}